import type { EnhancedProductFamilyId, EnhancedProductGroupId } from '#api/enhancements/enhancedTmsApiTypes'
import type { ViewDetailKey } from '#store/slices/configurationSlice'

export interface FilterState {
  search?: string
  operation?: 'AND' | 'OR'
  showFavorites?: boolean
  showEdited?: boolean
  showPrint?: boolean
  showInsights?: boolean
  displayGroup?: EnhancedProductGroupId[]
  displayFamilies?: EnhancedProductFamilyId[]
  collapseGroup?: EnhancedProductGroupId[]
  expandFamily?: EnhancedProductFamilyId
}

export function hasFilter(filter?: FilterState, view?: ViewDetailKey): boolean {
  return view === 'print' && filter?.showPrint ? filterCount(filter) > 1 : filterCount(filter) > 0
}

export function hasSearchFilter(filter?: FilterState): boolean {
  return !!filter?.search
}

export function hasActionFilter(filter?: FilterState): boolean {
  const count = filterCount(filter)
  return filter?.search ? count - 1 > 0 : count > 0
}

export function filterCount(filter?: FilterState): number {
  if (!filter) {
    return 0
  }

  return (
    ((filter.search?.length ?? 0) > 0 ? 1 : 0) +
    (filter.showFavorites ? 1 : 0) +
    (filter.showEdited ? 1 : 0) +
    (filter.showPrint ? 1 : 0) +
    (filter.showInsights ? 1 : 0) +
    // mutates the filter result to include all families of a group, yields no result in itself
    // ((filter.displayGroup?.length ?? 0) > 0 ? 1 : 0) +
    ((filter.displayFamilies?.length ?? 0) > 0 ? 1 : 0)
  )
}
